import Link from "next/link";

const SearchBreadcrumbComponent = ({ title: title }) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";

  return (
    <>
      <nav className='container' aria-label='breadcrumb'>
        <ol className='breadcrumb mb-0'>
          <li className='breadcrumb-item'>
            <Link href='/' legacyBehavior>
              <a>Home</a>
            </Link>
          </li>
          <li className='breadcrumb-item d-block d-md-none'>
            <Link href='/' legacyBehavior>
              <a>...</a>
            </Link>
          </li>
          <li className='breadcrumb-item'>
            <Link href='/search/-/-' legacyBehavior>
              <a>Application Search</a>
            </Link>
          </li>
          <li className='breadcrumb-item' aria-current='page'>
            {title}
          </li>
        </ol>
      </nav>
    </>
  );
};

export default SearchBreadcrumbComponent;
